/* Swissöra · il sito in cinque lingue (fr · en · es · de · it). Nour, 5 ott 2026.
   Il markup è scritto in francese. La lingua la decide snippets/swissora-lang.liquid prima che la pagina si veda
   (window.SW_LANG); qui si applica il dizionario della lingua (assets/i18n-<lingua>.js, chiave = frase francese)
   a ogni testo della pagina, anche a quelli che il carrello e il quiz cambiano dopo.
   Una frase senza traduzione esatta prova: 1) maiuscole/minuscole, 2) con i numeri messi da parte (prezzi, quantità),
   3) le poche frasi con dentro un nome. Le frasi che restano in francese vanno in PostHog (i18n_missing) per
   completare il dizionario. Sorgenti e processo: cartella lingue/ del cliente.
   data-no-i18n (quiz, simulatore, reel, prima/dopo) non ferma più la traduzione: serviva al vecchio motore FR⇆EN,
   che rimetteva il francese al ritorno. Per tenere fuori un pezzo si usa data-sw-keep. */
(function () {
  'use strict';
  var L = ['fr', 'en', 'es', 'de', 'it'];
  var NOMI = { fr: 'Français', en: 'English', es: 'Español', de: 'Deutsch', it: 'Italiano' };
  var d = document.documentElement;
  var lang = L.indexOf(window.SW_LANG) > -1 ? window.SW_LANG : 'fr';
  var why = window.SW_LANG_WHY || '';
  var DIZ = null, MAIU = null, TPL = null, applicato = false, ultimoSet = new WeakMap(), mancanti = {};
  var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, CODE: 1 };
  var ATTR = ['placeholder', 'aria-label', 'title', 'alt'];
  var NUM = /\d+(?:[.,]\d+)?/g;

  function norm(s) { return String(s).replace(/ | /g, ' ').replace(/[’‘]/g, "'").replace(/\s+/g, ' ').trim(); }

  // frasi con un nome o un pezzo variabile dentro
  var REGOLE = {
    en: [[/^Bon retour, (.+)$/, 'Welcome back, $1'], [/^(\d+) min de lecture$/, '$1 min read']],
    es: [[/^Bon retour, (.+)$/, 'Hola de nuevo, $1'], [/^(\d+) min de lecture$/, '$1 min de lectura']],
    de: [[/^Bon retour, (.+)$/, 'Schön, dass du wieder da bist, $1'], [/^(\d+) min de lecture$/, '$1 Min. Lesezeit']],
    it: [[/^Bon retour, (.+)$/, 'Bentornata, $1'], [/^(\d+) min de lecture$/, '$1 min di lettura']]
  };

  function prepara(dict) {
    DIZ = {}; MAIU = {}; TPL = {};
    Object.keys(dict).forEach(function (k) {
      var nk = norm(k), v = dict[k];
      if (!v) return;
      DIZ[nk] = v;
      MAIU[nk.toUpperCase()] = v.toUpperCase();
      var nums = nk.match(NUM);
      if (nums) {
        // modello con i numeri al posto giusto: vale solo se tutti i numeri del francese stanno nella traduzione
        var t = v, ok = true;
        nums.forEach(function (n, i) { if (t.indexOf(n) < 0) ok = false; else t = t.replace(n, '{' + i + '}'); });
        if (ok) TPL[nk.replace(NUM, '#')] = t;
      }
    });
  }

  function traduci(testo) {
    var k = norm(testo);
    if (!k || !/[A-Za-zÀ-ÿ]/.test(k)) return null;
    if (DIZ[k]) return DIZ[k];
    if (k === k.toUpperCase() && MAIU[k]) return MAIU[k];
    var nums = k.match(NUM);
    if (nums) {
      var t = TPL[k.replace(NUM, '#')];
      if (t) return t.replace(/\{(\d+)\}/g, function (_, i) { return nums[+i] || ''; });
    }
    var r = REGOLE[lang] || [];
    for (var i = 0; i < r.length; i++) if (r[i][0].test(k)) return k.replace(r[i][0], r[i][1]);
    return null;
  }

  function sembraFrancese(k) {
    return k.length > 3 && /[a-zà-ÿ]{3,}/i.test(k) && /[àâçéèêîôûùœ]|\b(vous|votre|vos|les|des|une|pour|avec|dans|sur|est|panier|commande|livraison|offert|cils|flacons?|cure|mois|jours?|semaines?)\b/i.test(k);
  }

  function nodo(n) {
    var v = n.nodeValue;
    if (!v || ultimoSet.get(n) === v) return;
    var t = traduci(v);
    if (t) {
      var lead = v.match(/^\s*/)[0], trail = v.match(/\s*$/)[0];
      var nv = lead + t + trail;
      if (nv !== v) { n.nodeValue = nv; ultimoSet.set(n, nv); }
    } else {
      var k = norm(v);
      if (sembraFrancese(k) && !mancanti[k]) mancanti[k] = 1;
    }
  }

  function attributi(el) {
    for (var i = 0; i < ATTR.length; i++) {
      var a = ATTR[i];
      if (el.hasAttribute && el.hasAttribute(a)) {
        var t = traduci(el.getAttribute(a));
        if (t) el.setAttribute(a, t);
      }
    }
  }

  function percorri(root) {
    if (!root) return;
    if (root.nodeType === 3) { nodo(root); return; }
    if (root.nodeType !== 1 || SKIP[root.tagName]) return;
    if (root.closest && root.closest('[data-sw-keep]')) return;
    attributi(root);
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT, {
      acceptNode: function (n) {
        if (n.nodeType === 1) return (SKIP[n.tagName] || (n.hasAttribute && n.hasAttribute('data-sw-keep'))) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_SKIP;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var n; while ((n = w.nextNode())) nodo(n);
    if (root.querySelectorAll) root.querySelectorAll('[placeholder],[aria-label],[title],[alt]').forEach(attributi);
  }

  function svela() { d.className = d.className.replace(/\s?sw-i18n-wait/g, ''); }

  function apply() {
    if (lang === 'fr' || !DIZ) return;
    percorri(document.body);
    var tt = traduci(document.title); if (tt) document.title = tt;
    applicato = true;
    svela();
  }

  // ---- il pagamento nella stessa lingua: /en/checkout porta al pagamento Shopify in inglese (lingue pubblicate)
  function pubblicata(l) { return (window.SW_LOCALI || []).indexOf(l) > -1; }
  function percorsoLingua() {
    window.SW_CHECKOUT_URL = (lang !== 'fr' && pubblicata(lang)) ? '/' + lang + '/checkout' : '/checkout';
    if (lang !== 'fr' && pubblicata(lang)) {
      document.querySelectorAll('form[action="/cart"]').forEach(function (f) { f.setAttribute('action', '/' + lang + '/cart'); });
      document.querySelectorAll('a[href="/checkout"]').forEach(function (a) { a.setAttribute('href', '/' + lang + '/checkout'); });
    }
  }

  // ---- il pulsante delle lingue (il «FR · EN» dell'intestazione e del menu del telefono)
  function stilePulsante() {
    if (document.getElementById('sw-lang-css')) return;
    var st = document.createElement('style'); st.id = 'sw-lang-css';
    st.textContent =
      '.sw-lang{position:relative;display:inline-flex}' +
      '.sw-lang .locale-pill__lang.is-on{opacity:1;font-weight:700}' +
      '.sw-lang__car{width:9px;height:9px;margin-left:5px;opacity:.6;transition:transform .2s}' +
      '.sw-lang.is-open .sw-lang__car{transform:rotate(180deg)}' +
      '.sw-lang__menu{position:absolute;top:calc(100% + 8px);right:0;z-index:1200;display:none;min-width:160px;padding:6px;background:var(--c-ivory,#F2EFE6);border:1px solid var(--c-ivory-3,#DED7C6);border-radius:12px;box-shadow:0 14px 34px rgba(22,19,17,.14)}' +
      '.sw-lang.is-open .sw-lang__menu{display:block}' +
      '.sw-lang--menu .sw-lang__menu{position:static;margin-top:8px;box-shadow:none}' +
      '.sw-lang__opt{display:flex;align-items:center;justify-content:space-between;gap:12px;width:100%;padding:10px 11px;border:0;border-radius:8px;background:none;color:var(--c-ink,#161311);font:500 13.5px/1 var(--font-body,inherit);text-align:left;cursor:pointer}' +
      '.sw-lang__opt:hover{background:rgba(22,19,17,.06)}' +
      '.sw-lang__opt[aria-current="true"]{font-weight:700}' +
      '.sw-lang__opt small{opacity:.55;font-weight:600;letter-spacing:.04em}';
    document.head.appendChild(st);
  }

  function pulsanti() {
    stilePulsante();
    document.querySelectorAll('.js-lang-toggle').forEach(function (b) {
      if (b.getAttribute('data-sw-lang')) return;
      b.setAttribute('data-sw-lang', '1');
      b.setAttribute('aria-haspopup', 'true'); b.setAttribute('aria-expanded', 'false');
      var cur = b.querySelector('.locale-pill__cur');
      b.innerHTML = '<span class="locale-pill__lang is-on">' + lang.toUpperCase() + '</span>' +
        '<svg class="sw-lang__car" viewBox="0 0 10 10" aria-hidden="true"><path d="M1.5 3.5 5 7l3.5-3.5" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        (cur ? cur.outerHTML : '<span class="locale-pill__cur">€</span>');
      var w = document.createElement('span');
      w.className = 'sw-lang' + (b.classList.contains('locale-pill--menu') ? ' sw-lang--menu' : '');
      b.parentNode.insertBefore(w, b); w.appendChild(b);
      var m = document.createElement('div'); m.className = 'sw-lang__menu'; m.setAttribute('role', 'menu'); m.setAttribute('data-sw-keep', '');
      m.innerHTML = L.map(function (l) {
        return '<button type="button" class="sw-lang__opt" role="menuitem" data-l="' + l + '" aria-current="' + (l === lang) + '">' + NOMI[l] + '<small>' + l.toUpperCase() + '</small></button>';
      }).join('');
      w.appendChild(m);
    });
  }

  document.addEventListener('click', function (e) {
    var opt = e.target.closest && e.target.closest('.sw-lang__opt');
    if (opt) { e.preventDefault(); set(opt.getAttribute('data-l')); return; }
    var b = e.target.closest && e.target.closest('.js-lang-toggle');
    document.querySelectorAll('.sw-lang.is-open').forEach(function (w) { if (!b || !w.contains(b)) { w.classList.remove('is-open'); } });
    if (b) {
      e.preventDefault();
      var w = b.closest('.sw-lang'); if (!w) return;
      var aperto = w.classList.toggle('is-open'); b.setAttribute('aria-expanded', String(aperto));
    }
  });

  function set(l) {
    if (L.indexOf(l) < 0) return;
    try { localStorage.setItem('swissora_lang', l); } catch (e) {}
    try { if (window.posthog) posthog.capture('lang_switch', { from: lang, to: l }); } catch (e) {}
    var p = location.pathname, m = p.match(/^\/(en|es|de|it)(\/.*|$)/);
    var resto = m ? (m[2] || '/') : p;
    var dest = (l !== 'fr' && pubblicata(l)) ? '/' + l + (resto === '/' ? '' : resto) : resto;
    var q = location.search.replace(/([?&])lang=[a-z]{2}&?/, '$1').replace(/[?&]$/, '');
    if (dest !== p) location.href = dest + q + location.hash; else location.reload();
  }

  // ---- testi che cambiano dopo (carrello, quiz, pulsante con il prezzo)
  function osserva() {
    if (!window.MutationObserver) return;
    var coda = [], prog = false;
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) {
        var r = ms[i];
        if (r.type === 'characterData') coda.push(r.target);
        else for (var j = 0; j < r.addedNodes.length; j++) coda.push(r.addedNodes[j]);
      }
      if (!prog) {
        prog = true;
        requestAnimationFrame(function () { var c = coda; coda = []; prog = false; c.forEach(percorri); });
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  function misura() {
    try {
      if (!window.posthog) return;
      posthog.register({ site_lang: lang, site_lang_why: why });
      if (lang === 'fr') return;
      setTimeout(function () {
        var k = Object.keys(mancanti).slice(0, 25);
        if (!k.length) return;
        var chiave = 'sw_i18n_m_' + lang + location.pathname;
        if (sessionStorage.getItem(chiave)) return;
        sessionStorage.setItem(chiave, '1');
        posthog.capture('i18n_missing', { lang: lang, page: location.pathname, count: Object.keys(mancanti).length, strings: k.map(function (s) { return s.slice(0, 140); }) });
      }, 6000);
    } catch (e) {}
  }

  function parti() {
    d.setAttribute('data-lang', lang);
    if (lang !== 'fr') d.setAttribute('lang', lang);
    pulsanti();
    percorsoLingua();
    if (lang === 'fr') { svela(); misura(); return; }
    var pronto = function () {
      var dict = window.SW_I18N && window.SW_I18N[lang];
      if (!dict) return false;
      prepara(dict); apply(); osserva(); misura();
      return true;
    };
    if (pronto()) return;
    if (!document.getElementById('sw-i18n-' + lang) && window.SW_CARICA_DIZ) window.SW_CARICA_DIZ(lang);
    var s = document.getElementById('sw-i18n-' + lang);
    if (s) s.addEventListener('load', pronto);
    var tent = 0, t = setInterval(function () { if (pronto() || ++tent > 40) { clearInterval(t); svela(); } }, 50);
  }

  window.SwissoraI18n = {
    apply: function () { if (lang !== 'fr' && DIZ) percorri(document.body); pulsanti(); },
    set: set,
    toggle: function () { set(lang === 'fr' ? 'en' : 'fr'); },
    traduci: function (s) { return DIZ ? traduci(s) : null; },
    get lang() { return lang; },
    get perche() { return why; }
  };

  if (window.SW_PAESE && typeof window.SW_PAESE.then === 'function' && !window.SW_LANG) {
    window.SW_PAESE.then(function (l) { lang = L.indexOf(l) > -1 ? l : 'fr'; why = window.SW_LANG_WHY || 'paese'; parti(); });
  } else {
    parti();
  }
})();
